module.exports = require('./readable').PassThrough



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/emr-webapp/~/readable-stream/passthrough.js
// module id = ../../../../readable-stream/passthrough.js
// module chunks = 5